/* MUI */
import { Box, Typography } from '@mui/material';

/* Shared */
import { Token } from 'application/Shared/Requests';

/* Hooks */
import { getUserTheme } from 'hooks/dataAccess/User/userTheme';

/* React */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';

/* Constants */
import IntegrationScriptFilename from './Constants/IntegrationScriptsFilename.json';

/* Helpers */
import { getScript } from './Helpers/utils';

class SyncroMSP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deploymentSteps: [],
            integrationName: 'Syncro MSP'
        };

        /* requests */
        this.Token = new Token();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const partnerToken = await this.Token.getToken();

        if (partnerToken) {
            this.setState({ hasToken: true });
            this.setDeploymentSteps(partnerToken);
        }
    };

    unload = () => {
        this.unmount = true;
        this.Token.cancel();
    };

    setDeploymentSteps = async (partnerToken) => {
        const { t } = this.props;

        let appVersion = '1.26.0';
        if (process.env.REACT_APP_VERSION) {
            appVersion = process.env.REACT_APP_VERSION;
        }

        const scriptCopyValue = await getScript({
            filename: IntegrationScriptFilename.syncroScript,
            token: partnerToken
        });

        const deploymentSteps = [
            {
                component: (
                    <Typography variant="h4">
                        {t('Integrations.script_code')}
                    </Typography>
                ),
                step: false
            },
            {
                note: t('Integrations.note'),
                step: false
            },
            {
                component: t('Integrations.Syncro.step1'),
                step: true
            },
            {
                component: t('Integrations.Syncro.step2'),
                step: true
            },
            {
                component: t('Integrations.set_the_name'),
                copyValue: t('Integrations.asm_version', {
                    appVersion
                }),
                step: true
            },
            {
                component: t('Integrations.set_the_description'),
                copyValue: t('Integrations.Syncro.step4.copyValue', {
                    date: new Date()
                }),
                step: true
            },
            {
                component: `${t('Integrations.set_the_category')}:`,
                step: true,
                stepValue: t('Integrations.Syncro.step5.stepValue')
            },
            {
                component: (
                    <Box>
                        {t('Integrations.Syncro.create_new_variable')}
                        <ul>
                            <li>{t('Integrations.Syncro.step6.varName')}</li>
                            <li>{t('Integrations.Syncro.step6.varType')}</li>
                            <li>{t('Integrations.Syncro.step6.varValue')}</li>
                        </ul>
                    </Box>
                ),
                step: true
            },
            {
                component: (
                    <Box>
                        {t('Integrations.Syncro.create_new_variable')}
                        <ul>
                            <li>{t('Integrations.Syncro.step7.varName')}</li>
                            <li>{t('Integrations.Syncro.step7.varType')}</li>
                            <li>{t('Integrations.Syncro.step7.varValue')}</li>
                        </ul>
                    </Box>
                ),
                step: true
            },
            {
                component: `${t('Integrations.set_the_fileType')}:`,
                step: true,
                stepValue: t('Common.powershell')
            },
            {
                component: `${t('Integrations.Syncro.step9')}:`,
                step: true,
                stepValue: t('Common.system')
            },
            {
                component: `${t('Integrations.Syncro.step10')}:`,
                step: true,
                stepValue: t('Integrations.Syncro.step10.time')
            },
            {
                component: t('Integrations.Syncro.step11'),
                copyValue: scriptCopyValue,
                step: true
            }
        ];

        if (!this.unmount) {
            this.setState({ deploymentSteps });
        }
    };

    render() {
        const { onboarding = false, session, t } = this.props;
        const { deploymentSteps, hasToken, integrationName } = this.state;
        const userTheme = getUserTheme(session?.user?.theme);

        return (
            <IntegrationWrapper
                hasToken={hasToken}
                deploymentSteps={deploymentSteps}
                headerTitle={t(integrationName)}
                img={`/images/${userTheme}/integrations/syncro_msp.png`}
                imgWidth="200px"
                onboarding={onboarding}
            />
        );
    }
}
export default withTranslation()(SyncroMSP);
